import { autoinject } from 'aurelia-dependency-injection';
import { bindable } from 'aurelia-framework';
import { ContractLine } from '../../services/customer-info-store';
import { DialogService } from 'aurelia-dialog';
import { ContractDetails, ContractDetailsParameters } from './license-contract-details';
import { formatNumber } from '../../utils/formatter';

@autoinject
export class LicenseStatusCreditTile {

    @bindable line: ContractLine;
    @bindable organizationid: string = "";
    @bindable hidechartbtn: boolean = false;
    @bindable chartonly: boolean = false;

    constructor(private dialogService: DialogService) {
    }

    attached() {
        console.log(`Chart only mode = ${this.chartonly} (type: ${typeof this.chartonly})`);
        if (this.chartonly === true) {
            console.log('Chart only mode, open chart directly');
            this.open();
         }
    }

    open() {
        console.log('clicked on open!');
        
        const contractDetailsParameters: ContractDetailsParameters = {
            contractLine: this.line,
            organizationId: this.organizationid
        };

        if (this.line.usageBundle.startDate) {
            const lock = this.chartonly ? true : false; // Lock the dialog if chart only mode is enabled
            this.dialogService.open({ viewModel: ContractDetails, model: contractDetailsParameters, lock: lock }).whenClosed(response => {
                console.log('closed!');
            });
        }
    }

    format(number: number, digits: number = 0) {
        return formatNumber(number, digits)
    }

    calculateTimeMarkerTooltipLeftPosition(timeMarkerPercentage) {
        /* 
            Tile layout: 7px margin > 253px slider > 8px margin
            Tooltip box has max width of 196px, and its position is tied to the time marker (which is on the slider, from 0px to 253px)
            Ideally, tooltip is centered above the time marker, so its left position must be -98px (relative to the marker)
            The tooltip must be positioned within the tile, so the absolute position of the tooltip must be:
                >= -7px (left side) and <= 65px (right side, which is 253+8 minus 196)

            Time marker percentage = 0% -> marker = 0px (tooltip box starts at -7px)
            Time marker percentage = 36% -> marker = 91px (box starts at -7px, as of this % the box must move to the right together with the marker)
            Time marker percentage = 64% -> marker = 163px (box starts at 65px, ends at 261px, as of this % the box must not move further to the right)
            Time marker percentage = 100% -> marker = 253px (box starts at 65px, ends at 261px)
        */

        const timeMarkerPos = timeMarkerPercentage/100 * 253;
        let relativeTooltipLeft = -98; // Ideal, centered above the marker
        let absoluteTooltipLeft = timeMarkerPos + relativeTooltipLeft;

        // Ensure actualTooltipLeft >= -7 and <= 81
        if (absoluteTooltipLeft < -7) {
            relativeTooltipLeft = (timeMarkerPos * -1) - 7; // Positions the tooltip at -7 from zero-point, relative to current marker position
        }
        else if (absoluteTooltipLeft > 65) {
            relativeTooltipLeft = (timeMarkerPos - 65) * -1; // Positions the tooltip at 81 from zero-point, which is 180 from right side, relative to current marker position
        }        

        console.log(`Calculated time marker tooltip left position for time marker at ${timeMarkerPercentage}% -> ${relativeTooltipLeft}px`)
        return relativeTooltipLeft;
    }
        
}


// WEBPACK FOOTER //
// ./ClientApp/app/components/licensing-overview/license-status-credit-tile.ts